import { FC } from 'react';
import { X } from 'lucide-react';
import type { File as ApiFile } from '@teachur/http-client';
import { ProjectFilePreviewPanel } from './ProjectFilePreviewPanel';

interface FilePreviewSidePanelProps {
  file?: ApiFile | null;
  onClose: () => void;
}

export const FilePreviewSidePanel: FC<FilePreviewSidePanelProps> = ({ file, onClose }) => {
  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center justify-between gap-3 px-4 py-3 border-b border-(--neutral-white-NW800) mr-[2%]">
        <h3 className="[font-size:var(--fs-h6)]! font-bold text-(--neutral-black-NB1000)! mb-0!">
          File Preview
        </h3>
        <button
          onClick={onClose}
          className="rounded-md text-(--neutral-black-NB500) hover:text-(--neutral-black-NB900) cursor-pointer"
          aria-label="Close file preview"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
      <ProjectFilePreviewPanel file={file} onClose={onClose} />
    </div>
  );
};
